/**
 * Domain Registry - Single source of truth for all domains in the system
 * Note: Domain types are defined in @game/config to avoid circular dependencies
 */

export * from "./domain-config";
export {
  ALL_DOMAINS,
  ALL_DOMAIN_IDS,
  DOMAINS,
  getDomain,
  getDomainsByLayer,
  isDomainId,
  type Domain,
  type DomainDefinition,
  type DomainId,
  type DomainLayer,
} from "@game/config";
